/* global http preloader */
const search = {
	el: {
		body: document.body,
		searchContainer: document.querySelector('.search'),
		searchContent: document.querySelector('.search__content'),
		searchOpenButton: document.querySelectorAll('.js-open-search'),
		searchCloseButton: document.querySelector('.js-close-search'),
		searchInput: document.querySelector('.js-autocomplete'),
		searchClear: document.querySelector('.js-clear-search'),
		searchForm: document.querySelector('.search__form'),
		searchTotalResultsContainer: document.querySelector('.search__total-results'),
		searchTotalResults: document.querySelector('.js-search-total-results'),
		searchFirstIndexResults: document.querySelector('.js-search-first-index'),
		searchLastIndexResults: document.querySelector('.js-search-last-index'),
		searchResults: document.querySelector('.search__results'),
		searchPagination: document.querySelector('.js-pagination'),
		searchFilter: document.querySelector('.js-search-filter')
	},

	vars: {
		currentPage: 1,
		ticking: false
	},

	fxOpenModal() {
		this.el.searchContainer.classList.add('search--open')
		this.el.body.classList.add('no-scroll-hidden')
	},

	fxCloseModal() {
		this.el.body.classList.remove('no-scroll-hidden')
		this.el.searchContainer.classList.remove('search--open')
		this.el.searchClear.style.display = 'none'
		this.el.searchTotalResultsContainer.style.display = 'none'
		this.el.searchInput.value = ''
		this.el.searchResults.innerHTML = ''
		this.el.searchPagination.innerHTML = ''
	},

	fxAutoComplete(element = this.el.searchInput) {

		if (!this.vars.ticking) {
			window.requestAnimationFrame(() => {
				preloader.fxPreloaderRemove(this.el.searchContainer)
				this.fxSearch(element)
				this.vars.ticking = false
			})

			this.vars.ticking = true
		}
	},

	fxClearSearch(button = this.el.searchClear) {
		if (button.classList.contains('js-clear-search'))
			this.el.searchInput.value = ''

		this.el.searchClear.style.display = 'none'
		this.el.searchTotalResultsContainer.style.display = 'none'
		this.el.searchResults.innerHTML = ''
		this.el.searchPagination.innerHTML = ''
	},

	fxSearch(element, page) {
		const currentPage = page ? Number(page) : this.vars.currentPage,
			callback = (response, data) => this.fxSearchCallback(response, data, currentPage)

		const formData = {
			term: element.value,
			page: currentPage,
			language: this.el.body.dataset.language
		}

		preloader.fxPreloaderAdd(this.el.searchContainer)
		http.fxPost(this.el.searchForm.action, formData, callback)
	},

	fxSearchCallback(_, data, page) {
		preloader.fxPreloaderRemove(this.el.searchContainer)

		const items = data.items,
			totalItems = data.totalRecords,
			itemsPerPage = 10

		this.el.searchTotalResultsContainer.style.display = 'block'
		this.el.searchClear.style.display = 'block'
		this.el.searchTotalResults.textContent = totalItems
		this.el.searchFirstIndexResults.textContent = items.length ? page * itemsPerPage - (itemsPerPage - 1) : 0
		this.el.searchLastIndexResults.textContent = items.length === itemsPerPage ? page * itemsPerPage : (page - 1) * itemsPerPage + items.length
		this.el.searchResults.innerHTML = ''
		this.el.searchPagination.innerHTML = ''

		this.el.searchPagination.removeAttribute('style')

		for (const item of items) {
			this.el.searchResults.innerHTML +=
				`
					<div class='search__results-item'>
						<h2 class='search__results-heading delta'>${item.title}</h2>
						<h3 class='search__results-posheading epsilon'>${item.description}</h3>
						<a class='search__results-link link' href=${item.link.url}>
							<span>${this.el.searchForm.dataset.caption}</span>
							<svg class="search__results-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M5 12h14m-7-7l7 7-7 7"></path>
							</svg>
						</a>
					</div>
				`
		}
		this.fxRenderPagination(data.pages, page)
	},

	fxRenderPagination(pages, currentPage) {
		const pagination = this.el.searchPagination

		pagination.innerHTML = ''

		for (let i = 0; i < pages.length; i++) {
			const active = i + 1 === currentPage ? 'is-active' : ''
			pagination.innerHTML += `<button class='search__pagination-item js-pagination-item js-scrollto ${active}' data-scroll='search' type='button'>${pages[i]}</button>`
		}

		for (const page of document.querySelectorAll('.js-pagination-item')) {
			page.addEventListener('click', e => {
				const target = e.currentTarget
				if (!isNaN(target.textContent)) {
					this.el.searchResults.innerHTML = ''
					this.fxSearch(this.el.searchInput, Number(target.textContent))
				}
			})
		}
	},

	events() {
		for (const button of this.el.searchOpenButton)
			button.addEventListener('click', () => this.fxOpenModal())

		this.el.searchCloseButton.addEventListener('click', () => this.fxCloseModal())

		this.el.searchFilter.addEventListener('click', e => {
			e.preventDefault()
			this.fxSearch(this.el.searchInput.value)
		})

		this.el.searchInput.addEventListener('input', e => e.currentTarget.value.length >= 3 ? this.fxAutoComplete() : this.fxClearSearch(e.currentTarget))

		this.el.searchInput.addEventListener('keydown', e => {
			if (e.key === 'Enter') {
				e.preventDefault()
				e.currentTarget.value.length >= 3 && this.fxSearch(e.currentTarget.value)
			}
		})

		this.el.searchClear.addEventListener('click', () => this.fxClearSearch())
	},

	init() {
		this.el.searchContainer && this.events()
	}
}

search.init()